/**
 * 报名审核预览
 * @description 报名审核预览
 * @author mll
 * @date 2020-11-7
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool } from '@/tool';
let { WizRow, WizCol, WizSpin } = component_tool;
let { WizContainer } = framework_tool;
import { modelUtils } from '@/utils';
import '@/styles/containers/workflow/procTask/auditBitInfo/applyDetail/index.less'

class ApplyDetail extends WizContainer {

    componentName = 'ApplyDetail';

    constructor(props) {
        super(props);
        this.state = {
            apply: {}
        }
    }

    static defaultProps = {}

    _componentWillMount() {
        this.doActions([
            {
                path: 'auditApplyDetail/getDetail',
                payload: {
                    key: 'auditApplyDetail',
                    apiParams: {
                        procInstId: this.props.procInstId
                    }
                }
            },
        ]);
    }

    _componentDidMount() { }

    propsAndStateOnChange = {
        auditApplyDetail: this._auditApplyDetail.bind(this)
    }

    _auditApplyDetail(nextProps, nextState) {
        let auditApplyDetail = nextProps['auditApplyDetail'];
        if (auditApplyDetail['success']) {
            nextState['apply'] = auditApplyDetail['data']
            return true;
        } else {
            wizNotice.error('获取审核信息失败，请稍后尝试')
        }
        return false
    }

    _render_rows = (record = this.state.apply, key, index) => {
        let data = [
            {
                title: '报名信息',
                items: [
                    { name: '报名名称', value: record['applyName'] },
                    { name: '开始时间', value: record['applyStartTime'] },
                    { name: '结束时间', value: record['applyEndTime'] },
                    { name: '报名方式', value: record['enrollWay'] ? '学员报名' : '站内管理员报名' },
                ]
            },
            {
                title: '报名学员',
                items: [
                    { name: '姓名', value: record['fullName'] },
                    { name: '账号', value: record['userName'] },
                    { name: '组织名称', value: record['orgName'] },
                    { name: '组织编码', value: record['orgCode'] },
                    { name: '岗位', value: record['positionName'] },
                    { name: '任职状态', value: record['id'] ? record['jobState'] ? '在职' : '离职' : '' },
                ]
            },
            {
                title: '计划安排',
                items: [
                    { name: '计划名称', value: record['planName'] },
                    { name: '开始时间', value: record['planStartTime'] },
                    { name: '结束时间', value: record['planEndTime'] },
                    { name: '地址', value: record['planAddress'] },
                ]
            }
        ]
        let infoType = record['infoType'];
        if (infoType) {
            data.push(
                {
                    title: '回执信息',
                    items: [
                        { name: record['infoType'] === 1 ? '文字信息' : '问卷信息', value: record['recordInfo'], titleCol: { span: 4 }, valueCol: { span: 20 } }
                    ]
                }
            )
        }
        return <>
            {
                data.map(d => {
                    return this._row_info(d['title'], d['items'], index, d['col'])
                })
            }
        </>
    }

    _row_info = (title = '', items = [{ name: '', value: '' }], index, col = {}) => {
        let rowProps = {
            type: 'flex', align: 'middle', justify: 'center', className: 'row'
        }
        let titleCol = {
            span: 22, xs: 20, sm: 20, className: 'label-col'
        }
        let contentCol = {
            span: 19, xs: 18, sm: 18, className: 'content-col'
        }
        return (
            <div key={title + '@' + index + '-view'} className='coordinate-apply-row-info'>
                <WizRow key={title + '-title-' + index} {...rowProps}>
                    <WizCol {...titleCol}><div className='title'>{title}</div></WizCol>
                </WizRow>
                <WizRow key={title + '-value-' + index} {...rowProps}>
                    <WizCol {...contentCol}>
                        <WizRow {...rowProps} {...col} className='row coordinate-apply-info-row-view'>
                            {items.map(({ name, value, titleCol = {}, valueCol = {} }) => {
                                return [
                                    <WizCol span={4}{...titleCol}><div className='name'>{name + (name && name !== '' ? ':' : '')}</div></WizCol>,
                                    <WizCol span={8}{...valueCol}><div className='value' >{value || ''}</div></WizCol>
                                ]
                            })}
                        </WizRow>
                    </WizCol>
                </WizRow>
            </div>
        )
    }

    _render() {
        return <WizSpin spinning={this.props.auditApplyDetailLoading} tip='加载中'>{this._render_rows()}</WizSpin>
    }
}

const mapStateToProps = (state, ownProps) => {

    const { auditApplyDetail } = state;

    const _auditApplyDetail = modelUtils.getModelEntity(auditApplyDetail, "auditApplyDetail");
    const load = modelUtils.getLoadingState(state, 'auditApplyDetail');
    return {
        auditApplyDetail: _auditApplyDetail,
        ...load
    }
};

export default connect(mapStateToProps)(ApplyDetail)
